import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { Auth } from './types'
import { RootState, PersonData } from '../types'

export const getDefaultState = () => {
  return {
    status: '',
    token: localStorage.getItem('ACCESS_TOKEN') || '',
    user: {
      id: '',
      name: '',
      lastName: '',
      userName: '',
      isAdmin: false,
      photo: ''
    },
    tokenValid: false,
    wsConnectionActive: false,
    session: {},
    connection: null,
    accountInformation: {
      account_type: '',
      active: false,
      address: {},
      country_id: '',
      created_by: '',
      created_timestamp: -1,
      emails: [],
      id: '',
      identification_number: '',
      identification_type: '',
      last_modified_by: '',
      last_modified_timestamp: -1,
      metadata: {},
      name: '',
      number: '',
      operation_mode: '',
      services: {},
      terms_and_conditions: {},
      version: ''
    },
    accountData: {
      meta: {
        business_account_id: '',
        business_user_id: ''
      },
      version: ''
    },
    latestVersionTermsConditions: '',
    termsConditionsBlocker: false,
    userIsAdmin: false,
    accountVersionAccepted: ''
  }
}

export const state: Auth = getDefaultState()
const namespaced = true

export const auth: Module<Auth, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
